const safeParse = (value, fallback = null) => {
    if (value === undefined || value === null || value === 'undefined' || value === 'null' || value === '') {
        return fallback;
    }
    try {
        return JSON.parse(value);
    } catch {
        return fallback;
    }
}

export const tenant = () => safeParse(localStorage.getItem('tenant'), {});
export const getCompanyById = (id) => tenant()?.companies?.filter(company => company._id === id)[0]
